import React, { useState } from 'react';
import { Volume2 } from 'lucide-react';
import MobileTitleSpacer from '../components/MobileTitleSpacer';
import SEO from '../components/SEO';
import { seoConfig } from '../utils/seoConfig';

const Tournage = () => {
  const [perchmanVideoOpen, setPerchmanVideoOpen] = useState(false);
  const skills = [
    {
      icon: '/images/recorder.png',
      title: 'Prise de Son',
      description:
        'Enregistrement son sur plateau et en extérieur',
    },
    {
      icon: '/images/perchman.png',
      title: 'Perchman',
      description:
        'Maîtrise de la perche et des techniques de captation son',
    },
  ];

  return (
    <>
      <SEO 
        title={seoConfig.tournage.title}
        description={seoConfig.tournage.description}
        keywords={seoConfig.tournage.keywords}
        url={seoConfig.tournage.url}
      />
      <div className="min-h-screen bg-black pt-20">
        {/* Header avec photo en fond, comme la page Studio */}
        <div className="relative overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: "url('/images/charles-perche.jpg')",
              opacity: 1,
              filter: "blur(3px)",
            }}
          />

          <div className="absolute inset-0 bg-black/55" />

          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
            <MobileTitleSpacer height="50px" />

            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-4"
              style={{ color: '#CCAA00' }}
            >
              TOURNAGE
            </h1>

            <div
              className="h-1 w-32 md:w-40 mb-6"
              style={{
                background: 'linear-gradient(to right, #CCAA00, transparent)',
              }}
            />

            <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl font-medium">
              Chef Opérateur Son • Perchman
            </p>
          </div>
        </div>

      {/* Compétences */}
      <h2 className="text-2xl sm:text-3xl font-black text-white mt-6 sm:mt-8 md:mt-10 mb-8 text-center">
        Compétences
      </h2>

      {/* ✅ 2 cartes centrées */}
      <div className="flex flex-wrap justify-center gap-6 sm:gap-8 md:gap-10 pb-16">
        {skills.map((skill, index) => {
          const Icon = skill.icon;
          return (
            <div
              key={index}
              onClick={skill.title === 'Perchman' ? () => setPerchmanVideoOpen(true) : undefined}
              role={skill.title === 'Perchman' ? 'button' : undefined}
              tabIndex={skill.title === 'Perchman' ? 0 : undefined}
              onKeyDown={skill.title === 'Perchman' ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') setPerchmanVideoOpen(true);
              } : undefined}
              className={`group relative rounded-2xl p-5 sm:p-6 md:p-8 border-2 transition-all duration-300 hover:scale-[1.03] flex flex-col items-center text-center justify-start w-[280px] sm:w-[300px] ${skill.title === 'Perchman' ? 'cursor-pointer' : ''}`}
              style={{
                background:
                  'linear-gradient(135deg, rgba(255,255,0,0.1) 0%, rgba(0,0,0,0.9) 100%)',
                borderColor: 'rgba(255,255,0,0.3)',
                boxShadow: '0 0 30px rgba(255,255,0,0.18)',
              }}
            >
              <div className="flex justify-center items-center h-24 sm:h-28 mb-3">
                {typeof Icon === 'string' ? (
                  <img
                    src={Icon}
                    alt={skill.title}
                    className="w-20 h-20 sm:w-24 sm:h-24 object-contain"
                  />
                ) : (
                  <Icon
                    className="text-yellow-400 transform group-hover:scale-110 transition-transform duration-300"
                    size={64}
                  />
                )}
              </div>

              <h3 className="text-white text-lg sm:text-xl font-bold mb-2">
                {skill.title}
              </h3>
              <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
                {skill.description}
              </p>
            </div>
          );
        })}
      </div>
      </div>

      {perchmanVideoOpen && (
        <div
          className="fixed inset-0 z-[11000] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setPerchmanVideoOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Vidéo Perchman"
        >
          <div
            className="relative w-full max-w-4xl"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setPerchmanVideoOpen(false)}
              className="absolute -top-11 right-0 text-white text-3xl leading-none hover:text-yellow-400 transition"
              aria-label="Fermer la vidéo"
            >
              ×
            </button>
            <video
              src="/videos/oh-le-perchman.mp4"
              controls
              autoPlay
              playsInline
              className="w-full max-h-[80vh] rounded-2xl bg-black shadow-2xl"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Tournage;
